import { connect } from "react-redux";

// Component
import ForgotPassword from "./ForgotPassword.jsx";
// Actions
import { forgotPassword } from "./forgotPasswordActions";

const mapStateToProps = state => ({
  forgot: state.forgot
});

const mapDispatchToProps = dispatch => ({
  forgotPassword: details => dispatch(forgotPassword({ ...details }))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPassword);
